import { setPosTop, resetPosTop } from './posTop'

export function trigger() {
  const navTrigger = document.querySelectorAll('.js-trigger-nav');
  if(navTrigger) {
    for (let i = 0; i < navTrigger.length; i++) {
      const el = navTrigger[i];
      el.addEventListener('click', function(e) {
        if(!document.body.classList.contains('is-nav-active')){
          setPosTop()
          document.body.classList.add('is-nav-active');
          window.scrollTo(0, 0)
        } else {
          document.body.classList.remove('is-nav-active');
          resetPosTop()
        }
        e.preventDefault();
      });
    }
  }

  const headerShareBubbleTrigger = document.querySelectorAll('.js-trigger-open-header-share-bubble');
  if(headerShareBubbleTrigger.length) {
    for(let i = 0; i < headerShareBubbleTrigger.length; i++) {
      const el = headerShareBubbleTrigger[i];
      el.addEventListener('click', function(e) {
        if(!document.body.classList.contains('is-header-share-bubble-active')){
          document.body.classList.add('is-header-share-bubble-active');
        } else {
          document.body.classList.remove('is-header-share-bubble-active');
        }
        e.preventDefault();
      });
    }
  }
}